// extracted by mini-css-extract-plugin
export default {"root":"app_root__fn33Y","main":"app_main__nXLxf"};